// extracted by mini-css-extract-plugin
export default {"Detail":"detail_Detail__-+bFd","title":"detail_title__oRypW","wrapper":"detail_wrapper__N+X06","content":"detail_content__WbHC3"};